// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__yZdDO","select":"index_select__g6cEv"};